import { Paper, CircularProgress } from "@material-ui/core";
import { useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAddedScheduleActivity } from "../../../../Redux/Actions/ActivityHistoryAction";
import { useEffect } from "react";

const ScheduleAddedContainer = () => {
  const activityHistoryData = useSelector((state) => state.activityHistoryData);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    getAddedScheduleActivity(dispatch, {
      pageNumber: activityHistoryData?.pageNumber,
      status: true,
    });
  }, []);

  const listInnerRef = useRef();

  const onScroll = () => {
    if (
      activityHistoryData?.pageNumber <= activityHistoryData?.totalPages - 1 &&
      !activityHistoryData?.loading
    ) {
      if (listInnerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
        if (Math.round(scrollTop + 1 + clientHeight) >= scrollHeight) {
          getAddedScheduleActivity(dispatch, {
            pageNumber: activityHistoryData?.pageNumber,
            status: false,
          });
        }
      }
    }
  };

  return (
    <div className="position-relative">
      <div
        className="height-350 overflow-y"
        onScroll={() => onScroll()}
        ref={listInnerRef}
      >
        {activityHistoryData?.activityData?.scheduleAdded?.map(
          (item, index) => (
            <div className="main-card-box pd-10 brd-grey" key={index}>
              <div className="d-flex-space-between flex-wrap w-100 pad-bottom-10  brderbtm d-flex-align-cent">
                <p className="fs-16 semi-bold">
                  {item?.memberAdded?.firstName} Added New Schedule
                </p>
                <button
                  className="small-btn"
                  onClick={() => history.push("/seasons")}
                >
                  Show
                </button>
              </div>
              <div className="mg-top-10">
                <p className="bold fs-18 mg-bottom-5">
                  {item?.schedule?.seasonWeek?.title}
                </p>
                <p className="bold fs-18 mt-1">
                  {item?.schedule?.homeSchool?.schoolName}
                  <span className="skBlue"> Vs</span>{" "}
                  {item?.schedule?.opponent?.schoolName}
                </p>
                <p className="my-1 text-secondary semi-bold">
                  Location : {item?.schedule?.location}
                </p>
                <p className="text-secondary semi-bold">
                  Date : {item?.schedule?.eventDate}
                </p>
              </div>
            </div>
          )
        )}

        {!activityHistoryData?.loading &&
          !activityHistoryData?.error &&
          activityHistoryData?.activityData?.scheduleAdded?.length == 0 && (
            <Paper className="activity-trending-container2  pd-10 mg-top-10">
              <p className="nodatabox">
                No feed available currently. Once you or your Coaches, Athletes
                share the content, it will become available here
              </p>
            </Paper>
          )}

        {!activityHistoryData?.loading && activityHistoryData?.error && (
          <p className="nodatabox">
            <Paper className="activity-trending-container2  pd-10 mg-top-10">
              <p className="nodatabox">{activityHistoryData?.error?.message}</p>
            </Paper>
          </p>
        )}
      </div>
      <div
        className="activity-history-loading-container"
        hidden={!activityHistoryData?.loading}
      >
        <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
          <CircularProgress
            className="rounded-circle"
            color="success"
            sx={{ fontSize: 10, color: "#002244" }}
            disableShrink
          />
        </div>
      </div>
    </div>
  );
};

export default ScheduleAddedContainer;
